import '../input/text-input';
import '../input/button-input';

import{ html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';

import { FormElement } from './form';
import { TextInput } from '../input/text-input';

declare const MAILCHIMP_ACCOUNT_ID: string;
declare const MAILCHIMP_LIST_ID: string;

@customElement('newsletter-form')
export class NewsletterForm extends FormElement {

	// Props

	@property({ type: String })
	target: string = '';

	@query('text-input')
	_textInput!: TextInput;

	@state()
    _crsf: string = '';

    // Lifecycle Hooks

    firstUpdated() {

        // add classes
        this.classList.add('Form', 'Form--newsletter');

		// handle slots
        const slot: HTMLElement | null = this.querySelector('[slot="crsf"]');
        if (slot) {
            this._crsf = slot.innerHTML;
            slot.remove();
        }
    }

    // Render

    render() {
        return html`
            <form @submit="${this._submit}">
                <header class="Form-header">
                    Newsletter
                </header>
                <div class="Form-body">
                    <text-input 
                        name="email" 
                        autocomplete="email" 
                        placeholder="Enter your email for updates"
                        .required="${ true }"
                    /></text-input>
                </div>
                <div class="Form-footer">
                    ${ this.submitButtonTemplate('newsletter', '→') }
                </div>
            </form>
        `;
    }

    createRenderRoot() { 
        return this;
    }

	// Methods

	protected async _submit(e?: Event) {
		if (e) e.preventDefault();
		const email = encodeURIComponent(this._textInput.value);
		if (!email.length) {
			window.alert('a valid email is required');
			return;
		} else {
			const url = `https://swissinstitute.us4.list-manage.com/subscribe?u=${MAILCHIMP_ACCOUNT_ID}&id=${MAILCHIMP_LIST_ID}&EMAIL=${email}`;
        	window.open(url, '_blank');
		}
    }

}